import { useEffect, useState } from 'react';
import { Container, Typography, Button, Box, useMediaQuery } from '@mui/material';
import { PostService } from '../../../services/post';
import { IPostPreview, IPostResponse } from '../../../interfaces/posts';
import { useNavigate } from 'react-router-dom';
import PreviewItem from '../../blog/components/preview';
import { ToggleCategory } from '../../../components/blogs/toggleCategory';

const NoticiasBlogSection = () => { 

  const navigate = useNavigate();

  const [posts, setPosts] = useState<IPostPreview[]>([]);
  const instance = new PostService();

  const [selected, setSelected] = useState<string>("Notícia");

  const get = () => {
    instance.get_all(1, 3, selected)
    .then((data : IPostResponse) => {
      console.log("data", data)
      if(Array.isArray(data.items)) setPosts(data.items)
    })
    .catch(error => [])
  }
  useEffect(() => {
    get();
  }, []);

  useEffect(() => {
    get();
  }, [selected]);

  const isMobile = useMediaQuery("(max-width:768px)");

  if(posts && posts.length <= 0 ) return <></>

  return (
    <Container maxWidth="lg" style={{ 
      padding: '2rem 0', 
      textAlign: 'center',
    
       }}>

      <ToggleCategory selected={selected} setSelected={setSelected}/>

      <Typography  sx={{pt: 2}} variant="body1" color="white" paragraph textAlign="justify">
        Acompanhe nosso blog para se manter informado sobre saúde, bem-estar e novidades do Innova Plano de Saúde.
        Conteúdos relevantes e atuais com dicas práticas para cuidar de você e da sua família.
      </Typography>

      <Box component="ul" style={{ display: "flex", flexFlow: isMobile ? "column" : "row", gap: "0.5em"}}>
        {
          posts?.map(item => <PreviewItem key={item.id} post={item}/>)
        }

      </Box>

      <Box mt={4}>
        <Button
          variant="outlined"
          color="warning"
          size="large"
          sx={{
            color: 'white',
            borderColor: 'white',
            '&:hover': {
              borderColor: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          Ver Todos os Artigos
        </Button>

      </Box>
    </Container>
  );
}



export default NoticiasBlogSection;
